/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { BleChannelDto } from './ble-channel-dto';
 /**
 *
 *
 * @export
 * @interface ValidateTotpResponseDto
 */
export interface ValidateTotpResponseDto {

    /**
     * @type {string}
     * @memberof ValidateTotpResponseDto
     */
    publicKey: string;

    /**
     * @type {BleChannelDto}
     * @memberof ValidateTotpResponseDto
     */
    auth: BleChannelDto;

    /**
     * @type {BleChannelDto}
     * @memberof ValidateTotpResponseDto
     */
    comm: BleChannelDto;
}
